module.exports = __webpack_public_path__ + "5cc1691508b3bcbaa068acbd856756a4.svg";